import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Image from '../atoms/Image';
import GatsbyImage from 'gatsby-image';

const Holder = styled.div`
  margin: 0 1rem 1rem 1rem;
  width: calc(100% - 2rem);
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const ChildrenHolder = styled.div`
  width: 100%;
  max-width: 30rem;
  position: relative;
  z-index: 2;
`;

function LargeImage( { imgName, children, fluid } ) {

  const styles = {
    position: 'absolute',
    zIndex: 1,
    top: '0',
    left: '0',
    width: '100%',
    height: '100%'
  };

  return (
    <Holder>
      {imgName && <Image
        style={styles}
        imgName={imgName}/>}
      {fluid && <GatsbyImage
        style={styles}
        fluid={fluid}/>}
      {children && <ChildrenHolder>{children}</ChildrenHolder>}
    </Holder>
  )
}

LargeImage.propTypes = {
  imgName: PropTypes.string.isRequired,
};

LargeImage.defaultProps = {
  imgName: 'Stranger'
};

export default LargeImage;
